// PostHog feature flags read by the back-office and the API.
export const FEATURE_FLAG_KEYS = [
  "advance-payment-pay-modal",
  "advance-payment-request-detail-v2",
  "batch-send-extension-amendment-to-pld",
  "batch-send-timesheet-to-pld",
  "commercial-conditions-list-v2",
  "consultant-kpi",
  "contacts-v2",
  "credit-score-allianz",
  "demo",
  "expense-claim-pay-modal",
  "expense-claim-request-detail-v2",
  "expense-claim-request-form-ds",
  "expense-claim-request-pbac",
  "expense-claim-request-review-sheet",
  "hiring-pool-health",
  "job-matrix-classification",
  "medical-checkup-request-form-ds",
  "medical-leave-banner",
  // TODO: "menco" swaps the whole nav bar for Menco's; split it into per-area flags (e.g. enable-crm, enable-contracts)
  "menco",
  "mission-order-form",
  "organization-select",
  "paper-timesheet-ocr",
  "pay-tracking-cooptation",
  "ppe-distribution",
  "professional-card-compliance-resolution",
  "professional-card-update-resolution",
  "recruitment-office-invoice-request-v2",
  "remove-contact-button",
  "remuneration-elements",
  // The signature engine sends commercial conditions instead of the legacy Docuseal flow
  "signature-engine",
  "talent-merge",
  "third-party-notices",
  "todo-list",
] as const;

export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number];
